import { render, staticRenderFns } from "./model_grid_management.vue?vue&type=template&id=513ccdbe&scoped=true&lang=html"
import script from "./model_grid_management.vue?vue&type=script&lang=js"
export * from "./model_grid_management.vue?vue&type=script&lang=js"
import style0 from "./model_grid_management.vue?vue&type=style&index=0&id=513ccdbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ccdbe",
  null
  
)

export default component.exports